<template>
  <div id="app">
    <transition name="page" mode="out-in">
      <component v-if="layout" :is="layout"></component>
    </transition>
  </div>
</template>

<script>
// Load layout components dynamically.
const requireContext = require.context('../layouts', false, /.*\.vue$/)

const layouts = requireContext.keys()
  .map(file =>
    [file.replace(/(^.\/)|(\.vue$)/g, ''), requireContext(file)]
  )
  .reduce((components, [name, component]) => {
    components[name] = component
    return components
  }, {})

import MaterialIcons from './../../../../node_modules/quasar-framework/icons/material-icons'
import { QAjaxBar } from 'quasar-framework'

export default {
  el: '#app',

  data: () => ({
    layout: null,
    defaultLayout: 'default'
  }),

  metaInfo () {
    const { appName } = window.config

    return {
      title: appName,
      titleTemplate: `%s · ${appName}`
    }
  },

  components: {
      QAjaxBar
  },

  mounted(){
    this.setMaterialIcons();
    this.$q.icon.set(MaterialIcons)
  },

  methods: {
    /**
     * Set the application layout.
     *
     * @param {String} layout
     */
    setLayout (layout) {
      if (!layout || !layouts[layout]) {
        layout = this.defaultLayout
      }

      this.layout = layouts[layout]
    },

    setMaterialIcons() {
      MaterialIcons.input.clear = 'fa icon-close'
      MaterialIcons.input.dropdown = 'fa icon-chevron-down'
      MaterialIcons.pagination.prev = 'fa icon-chevron-left'
      MaterialIcons.pagination.next = 'fa icon-chevron-right'
    }
  }
}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/App.vue